import React from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Box,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PercentIcon from "@mui/icons-material/Percent";
import PeopleIcon from "@mui/icons-material/People";
import { useNavigate, useLocation } from "react-router-dom";

const drawerWidth = 240;

export default function AccountantSidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { text: "Dashboard", icon: <DashboardIcon />, path: "/accountant" },
    {
      text: "Bank Feeds",
      icon: <AccountBalanceIcon />,
      path: "/accountant/bank-feeds",
    },
    {
      text: "Banking",
      icon: <AccountBalanceWalletIcon />,
      path: "/accountant/banking",
    },
    { text: "VAT", icon: <PercentIcon />, path: "/accountant/vat" },
    { text: "Reports", icon: <AssessmentIcon />, path: "/accountant/reports" },
    { text: "Clients", icon: <PeopleIcon />, path: "/accountant/client-list" },
  ];

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: drawerWidth,
          boxSizing: "border-box",
          backgroundColor: "#f9fafb",
          borderRight: "1px solid #e5e7eb",
        },
      }}
    >
      <Toolbar>
        <Typography variant="h6" noWrap fontWeight={700} color="primary">
          SortlyBooks
        </Typography>
      </Toolbar>
      <Box sx={{ overflow: "auto" }}>
        <List>
          {menuItems.map((item) => {
            const isActive = location.pathname.startsWith(item.path);
            return (
              <ListItem
                button
                key={item.text}
                onClick={() => navigate(item.path)}
                sx={{
                  backgroundColor: isActive ? "#e0f2fe" : "transparent",
                  "&:hover": { backgroundColor: "#e0f2fe" },
                }}
              >
                <ListItemIcon
                  sx={{
                    color: isActive ? "primary.main" : "inherit",
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={item.text}
                  primaryTypographyProps={{
                    fontWeight: isActive ? "bold" : "normal",
                    color: isActive ? "primary.main" : "inherit",
                  }}
                />
              </ListItem>
            );
          })}
        </List>
      </Box>
    </Drawer>
  );
}
